// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import RfqCustomQuoteDetailsState from "@ces/App/Store/Selectors/RfqQuoteDetailsSelectors";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: RfqCustomQuoteDetailsState = {
    priceBreakValidations: [],
};

const reducer = {
    "Pages/RfqCustomQuoteDetails/SetQuoteId": (
        draft: Draft<RfqCustomQuoteDetailsState>,
        action: { quoteNumber: string },
    ) => {
        draft.quoteNumber = action.quoteNumber;
    },
    "Pages/RfqCustomQuoteDetails/BeginApplyQuote": (draft: Draft<RfqCustomQuoteDetailsState>) => {
        draft.isApplingQuote = true;
    },
    "Pages/RfqCustomQuoteDetails/CompleteApplyQuote": (draft: Draft<RfqCustomQuoteDetailsState>) => {
        draft.isApplingQuote = false;
    },
};

const xRfqQuoteDetails = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xRfqQuoteDetails = xRfqQuoteDetails;

export type xRfqCustomQuoteDetailsState = {
    xRfqQuoteDetails: RfqCustomQuoteDetailsState;
} & ApplicationState;

type xRfqQuoteDetailsReducers = {
    [key: string]: typeof xRfqQuoteDetails;
};

export type xRfqQuoteDetailsActions =
    | Parameters<xRfqQuoteDetailsReducers[keyof xRfqQuoteDetailsReducers]>[1]
    | AnyAction;
